module.exports = __webpack_public_path__ + "static/media/withGrid.6fada65f.jpg";